import React from 'react';
import { LoaderAnimation } from 'src/components';
import './full-page-loader.scss';

export default function FullPageLoader(props) {
  return (
    <div>
      {props?.showLoader && (
        <div className="FullPageLoader">
          <div className="has-text-centered loader-container">
            <LoaderAnimation height={'100%'} width={'100%'} />
          </div>
        </div>
      )}
    </div>
  );
}
